import { Component } from 'react';

import InputField from '../../../components/inputs/inputField';
import SelectField from '../../../components/inputs/selectField';

class InventoryInfo extends Component {
    render() {
        const { editedItem, requiredFields, editItemField } = this.props;

        return (
            <div className="sectionBody">
                <div className="sectionBlock">
                    <h2 className='blockHeader'>Basic Details</h2>
                    <InputField
                        label="Name"
                        value={editedItem.name}
                        required={true}
                        errorTrigger={requiredFields.name}
                        type="text"
                        onChange={(e) => editItemField('name', e.target.value)}
                    />

                    <InputField
                        label="Category"
                        value={editedItem.category}
                        type="text"
                        onChange={(e) => editItemField('category', e.target.value)}
                    />

                    <InputField
                        label="Reference Number"
                        value={editedItem.referenceNumber}
                        type="text"
                        onChange={(e) => editItemField('referenceNumber', e.target.value)}
                    />

                    <InputField
                        label="Vendor"
                        value={editedItem.vendor}
                        type="text"
                        onChange={(e) => editItemField('vendor', e.target.value)}
                    />
                    <SelectField
                        label="Status"
                        value={this.props.statusOptions.find((s) => s.value == editedItem.status)}
                        options={this.props.statusOptions}
                        type="number"
                        onChange={(e) => editItemField('status', e.value)}
                    />
                    <InputField
                        label="Tracking Number"
                        value={editedItem.trackingNumber}
                        type="text"
                        onChange={(e) => editItemField('trackingNumber', e.target.value)}
                    />
                    <InputField
                        label="Arrival Date"
                        value={editedItem.arrivalDate}
                        type="date"
                        onChange={(e) => editItemField('arrivalDate', e.target.value)}
                        inputIcon={<i className="las la-calendar" />}
                    />
                    <InputField
                        label="Post Event Plan"
                        value={editedItem.postEventPlan}
                        type="text"
                        onChange={(e) => editItemField('postEventPlan', e.target.value)}
                    />
                    <InputField
                        label="Quantity"
                        value={editedItem.quantity}
                        type="number"
                        onChange={(e) => editItemField('quantity', e.target.value)}
                    />
                    <InputField
                        label="Price"
                        value={editedItem.price}
                        type="currency"
                        onChange={(e) => editItemField('price', e.target.value)}
                    />

                    <InputField
                        label="Total"
                        value={editedItem.quantity * editedItem.price}
                        type="currency"
                        disabled={true}
                        inputIcon={<i className="las la-lock lightGray" />}
                    />
                </div>
            </div>
        );
    }
}

export default InventoryInfo;
